import { Overlay } from '@components/Layout/Overlay';
import { useColorScheme } from '@contexts/ColorSchemeContext';
import { User } from '@lib/types/common/User';
import { OrganizationSwitcher } from './OrganizationSwitcher/OrganizationSwitcher';
import { UserInfo } from './UserInfo';
import { UserMenuDarkModeSwitch } from './UserMenuDarkModeSwitch';
import { UserMenuSection } from './UserMenuSection';
import { UserMenuSection as UserMenuSectionType } from './types';

type UserMenuContentProps = {
  user?: User;
  sections: UserMenuSectionType[];
  className?: string;
  switchOrganizationMicrocopy?: string;
  restrictedOrganizationMicrocopy?: string;
  darkModeMicrocopy?: string;
};

export const UserMenuContent = ({
  user,
  sections,
  className = '',
  switchOrganizationMicrocopy,
  restrictedOrganizationMicrocopy,
  darkModeMicrocopy = 'Dark Mode',
}: UserMenuContentProps) => {
  const { enabled: isDarkModeEnabled } = useColorScheme();
  // asv2 lists dark mode last, right above Sign out.
  const signOutSectionIndex = sections.findIndex(
    (section) => section.signOutIndex !== -1
  );
  const darkModeSectionIndex =
    signOutSectionIndex === -1 ? sections.length - 1 : signOutSectionIndex;
  const showDarkMode = Boolean(user) && isDarkModeEnabled;

  return (
    <>
      <Overlay />
      <div className={`z-modal relative ${className}`}>
        {user && <UserInfo user={user} />}
        {user && (
          <OrganizationSwitcher
            switchOrganizationMicrocopy={switchOrganizationMicrocopy}
            restrictedOrganizationMicrocopy={restrictedOrganizationMicrocopy}
          />
        )}
        <ul>
          {sections.map((section, index) => {
            const hasDarkMode = showDarkMode && index === darkModeSectionIndex;

            return (
              <UserMenuSection
                key={section.items.reduce((acc, item) => acc + item.value, '')}
                display={section.display}
                items={section.items}
                extraItem={
                  hasDarkMode && (
                    <UserMenuDarkModeSwitch label={darkModeMicrocopy} />
                  )
                }
                extraItemIndex={
                  section.signOutIndex === -1 ? undefined : section.signOutIndex
                }
              />
            );
          })}
        </ul>
      </div>
    </>
  );
};
